"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var propTypes = {
  businessName: _propTypes.string,
  businessWebsite: _propTypes.string,
  campaignName: _propTypes.string,
  customerId: _propTypes.string,
  market: _propTypes.string,
  onClose: _propTypes.func,
  otherProps: _propTypes.any,
  product: _propTypes.string,
  products: _propTypes.array,
  productIntent: _propTypes.string,
  source: _propTypes.string.isRequired,
  sourceApp: _propTypes.string.isRequired,
  renderMode: _propTypes.string
};
var _default = exports.default = propTypes;